$(".al-swiper").each(function (index, element) {
    var $this = $(element);
    var laptop = $this.data("laptop") || 1;
    var preview = $this.data("preview") || 1;
    var tablet = $this.data("tablet") || 1;
    var mobile = $this.data("mobile") || 1;
    var mobileSm = $this.data("mobile-sm") !== undefined ? $this.data("mobile-sm") : mobile;
    var mobileSsm = $this.data("mobile-ssm") !== undefined ? $this.data("mobile-ssm") : mobile;

    var spacing = $this.data("space");
    var spacingMd = $this.data("space-md");
    var spacingLg = $this.data("space-lg");
    var spacingXxl = $this.data("space-xxl");

    if (spacing !== undefined && spacingMd === undefined && spacingLg === undefined) {
        spacingMd = spacing;
        spacingLg = spacing;
    } else if (spacing === undefined && spacingMd !== undefined && spacingLg === undefined) {
        spacing = 0;
        spacingLg = spacingMd;
    }
    spacing = spacing || 0;
    spacingMd = spacingMd || 0;
    spacingLg = spacingLg || 0;
    spacingXxl = spacingXxl || 1;

    var perGroup = $this.data("pagination") || 1;
    var perGroupSm = $this.data("pagination-sm") || 1;
    var perGroupMd = $this.data("pagination-md") || 1;
    var perGroupLg = $this.data("pagination-lg") || 1;
    var gridRows = $this.data("grid") || 1;
    var cursorType = $this.data("cursor") ?? false;
    var loop = $this.data("loop") ?? false;
    var loopMd = $this.data("loop-md") ?? false;
    var effect = $this.data("effect") || "slide";
    var atPlay = $this.data("auto"); // True || False
    var speed = $this.data("speed") || 800;
    var delay = $this.data("delay") || 1000;
    var direction = $this.data("direction") || "horizontal";
    var centered = $this.data("center") ?? false;
    var init = $this.data("init") || 0;
    var touch = $this.data("touch") ?? true;
    var pauseHover = $this.data("pause-hover") ?? true;
    var typePag = $this.data("type-pagination") ?? "bullets";
    var isNumberType = $this.hasClass("swiper-type-number");
    var isNumberType2 = $this.hasClass("swiper-type-number-2");

    var isScrollbarType = $this.hasClass("swiper-type-scrollbar");
    var scrollbarEl =
        $this.find(".al-sw-scrollbar")[0] ||
        $this.closest(".al-btn-swiper-main").find(".al-sw-scrollbar")[0] ||
        $this.closest(".al-pag-swiper").find(".al-sw-scrollbar")[0];

    var scrollbarConfig = false;

    if (isScrollbarType && scrollbarEl) {
        scrollbarConfig = {
            el: scrollbarEl,
            draggable: true,
            dragSize: "auto",
        };
    }

    var circleProgress = $this.find(".sw-circle-prg")[0];
    var isCircleProgress = !!circleProgress;

    var paginationEl =
        $this.find(".al-sw-pagination")[0] ||
        $this.closest(".al-btn-swiper-main").find(".al-sw-pagination")[0] ||
        $this.closest(".al-pag-swiper").find(".al-sw-pagination")[0];

    var currentNumberEl = $this.find(".current-number-slide")[0] ||
        $this.closest(".al-btn-swiper-main").find(".current-number-slide")[0];

    var fractionEl = $this.closest(".al-btn-swiper-main")
        .find(".thumbs-pagination")[0];

    var paginationConfig = false;

    var isNumberType2 = $this.hasClass("swiper-type-number-2");

    if (isNumberType && fractionEl) {
        paginationConfig = {
            el: fractionEl,
            type: "fraction",
            renderFraction: function (currentClass, totalClass) {
                return `
                <span class="${currentClass}"></span>
                <span class="swiper-slice"></span>
                <span class="${totalClass}"></span>
            `;
            },
        };

    } else if (isNumberType2 && paginationEl) {
        paginationConfig = {
            el: paginationEl,
            clickable: true,
            renderBullet: function (index, className) {
                return `<span class="${className}">${index + 1}</span>`;
            },
        };

    } else if (paginationEl && !isCircleProgress) {
        paginationConfig = {
            el: paginationEl,
            type: typePag,
            clickable: typePag === "bullets",
        };
    }

    var swiperT = new Swiper($this[0], {
        direction: direction,
        speed: speed,
        centeredSlides: centered,
        slidesPerView: mobile,
        spaceBetween: spacing,
        slidesPerGroup: perGroup,
        grabCursor: cursorType,
        loop: loop,
        effect: effect,
        initialSlide: init,
        touchStartPreventDefault: touch,
        noSwiping: true,
        noSwipingClass: 'no-swipe',
        autoplay: atPlay
            ? {
                delay: delay,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseHover,
            }
            : false,
        grid: {
            rows: gridRows,
            fill: "row",
        },
        scrollbar: scrollbarConfig,
        pagination: paginationConfig,
        observer: true,
        observeParents: true,
        navigation: {
            nextEl: [
                $this.find(".nav-next-swiper")[0],
                $this.closest(".al-btn-swiper-main").find(".nav-next-swiper")[0],
                $this.closest(".box-swiper").find(".nav-next-swiper")[0],
                $this.closest(".container").find(".group-btn-slider .nav-next-swiper")[0],
            ],
            prevEl: [
                $this.find(".nav-prev-swiper")[0],
                $this.closest(".al-btn-swiper-main").find(".nav-prev-swiper")[0],
                $this.closest(".box-swiper").find(".nav-prev-swiper")[0],
                $this.closest(".container").find(".group-btn-slider .nav-prev-swiper")[0],
            ],
        },
        breakpoints: {
            425: {
                slidesPerView: mobileSsm,
                spaceBetween: spacing,
                slidesPerGroup: perGroup,
                grid: {
                    rows: gridRows,
                    fill: "row",
                },
            },
            575: {
                slidesPerView: mobileSm,
                spaceBetween: spacing,
                slidesPerGroup: perGroupSm,
                grid: {
                    rows: gridRows,
                    fill: "row",
                },
            },
            768: {
                slidesPerView: tablet,
                spaceBetween: spacingMd,
                slidesPerGroup: perGroupMd,
                grid: {
                    rows: gridRows,
                    fill: "row",
                },
            },
            1200: {
                slidesPerView: preview,
                spaceBetween: spacingLg,
                slidesPerGroup: perGroupLg,
                grid: {
                    rows: gridRows,
                    fill: "row",
                },
            },
            1600: {
                slidesPerView: laptop === 1 ? preview : laptop,
                spaceBetween: spacingXxl === 1 ? spacingLg : spacingXxl,
                slidesPerGroup: perGroupLg,
                grid: {
                    rows: gridRows,
                    fill: "row",
                },
            },
        },
        on: {
            init: function (swiper) {
                if (currentNumberEl) {
                    currentNumberEl.textContent = String(swiper.realIndex + 1).padStart(2, "0");
                }
                updateSectImage(swiper);
            },

            slideChange: function (swiper) {
                if (currentNumberEl) {
                    currentNumberEl.textContent = String(swiper.realIndex + 1).padStart(2, "0");
                }
                updateSectImage(swiper);
            },

            autoplayTimeLeft(swiper, time, progress) {
                if (!isCircleProgress) return;

                var circle = circleProgress.querySelector(".progress-bar");
                var number = circleProgress.querySelector(".pagination-number");
                var circumference = 138;

                if (circle) {
                    circle.style.strokeDashoffset = circumference * progress;
                }

                if (number) {
                    number.textContent = swiper.realIndex + 1;
                }
            }
        }
    });

    if ($this.hasClass("view-auto") && atPlay) {
        swiperT.autoplay.stop();

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    swiperT.params.autoplay = {
                        delay: delay,
                        disableOnInteraction: false,
                        pauseOnMouseEnter: pauseHover,
                    };
                    swiperT.autoplay.start();
                } else {
                    swiperT.autoplay.stop();
                }
            });
        }, {
            threshold: 0.3
        });

        observer.observe($this[0]);
    }

    var $lookbookHover = $this.closest(".al-lookbook-hover");
    $lookbookHover.find(".swiper-button")
        .off("mouseenter.lookbook mouseleave.lookbook click.lookbook")
        .on("mouseenter.lookbook", function () {
            var slideIndex = $(this).data("slide");
            swiperT.slideTo(slideIndex, 500, false);
            $lookbookHover.find(".card-product").removeClass("active");
            $lookbookHover.find(".card-product").eq(slideIndex).addClass("active");
        })
        .on("mouseleave.lookbook", function () {
            $lookbookHover.find(".card-product").removeClass("active");
        })
        .on("click.lookbook", function () {
            var slideIndex = $(this).data("slide");
            $lookbookHover.find(".card-product").eq(slideIndex).toggleClass("clicked");
        });

    
    function updateSectImage(swiper) {
        const $swiper = $(swiper.el);
        const $section = $swiper.closest(".section-testimonial");

        if (!$section.length) return;

        const index = swiper.realIndex;

        const $imgs = $section.find(".sect-image img");

        $imgs.removeClass("active");
        $imgs.eq(index).addClass("active");
    }
});

if ($(".al-sw-thumbs").length > 0) {
    var $this = $(".al-sw-thumbs");
    var thumbEffect = $this.find(".sw-thumb").data("effect") || "slide";

    var thumbSwiper = new Swiper(".sw-thumb", {
        spaceBetween: 6,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        speed: 800,
        slidesPerView: 3,
        centeredSlides: true,
        initialSlide: 1,
        slideToClickedSlide: true,
    });

    var mainSwiper = new Swiper(".sw-main-thumb", {
        grabCursor: true,
        speed: 800,
        spaceBetween: 20,
        initialSlide: 1,
        navigation: {
            prevEl: [
                $this.find(".nav-prev-swiper")[0],
            ],
            nextEl: [
                $this.find(".nav-next-swiper")[0],
            ],
        },
        scrollbar: {
            el: [
                $this.find(".al-sw-scrollbar")[0],
            ],
            draggable: true,
            dragSize: "auto",
            clickable: true,
        },
    });
    thumbSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = thumbSwiper;
}
if ($(".swiper-thumbs-wrap").length > 0) {
    var $this = $(".swiper-thumbs-wrap");
    var thumbEffect = $this.find(".sw-thumbs_sub").data("effect") || "slide";

    var thumbSwiper = new Swiper(".sw-thumbs_sub", {
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        speed: 800,
        slidesPerView: 1,
        spaceBetween: 16,
        centeredSlides: true,
        slideToClickedSlide: true,
    });

    var mainSwiper = new Swiper(".sw-thumbs_main", {
        grabCursor: true,
        speed: 800,
        initialSlide: 1,

        navigation: {
            prevEl: ".sw-thumbs_main .nav-prev-swiper",
            nextEl: ".sw-thumbs_main .nav-next-swiper",
        },

        pagination: {
            el: ".sw-thumbs_main .al-sw-pagination",
        },

        on: {
            init: function () {
                updateFraction(this);
            },
            slideChange: function () {
                updateFraction(this);
            }
        }
    });

    function updateFraction(swiper) {
        var current = swiper.realIndex + 1;
        var total = swiper.slides.length;

        document.querySelector(".pagination-text").textContent =
            current + "/" + total;
    }
    thumbSwiper.controller.control = mainSwiper;
    mainSwiper.controller.control = thumbSwiper;
}
if ($(".slider-thumb-wrap").length > 0) {
    const contentThumbSlider = new Swiper(".slider-content-thumb", {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        speed: 800,
        on: {
            slideChange: function () {
                const activeIndex = this.realIndex;
                $(".btn-thumbs").removeClass("active");
                $(".btn-thumbs").eq(activeIndex).addClass("active");
            },
        },
    });

    $(".btn-thumbs").on("click", function () {
        const index = $(this).index();
        $(".btn-thumbs").removeClass("active");
        $(this).addClass("active");
        contentThumbSlider.slideToLoop(index);
    });
}

if ($(".al-sw-mobile").length > 0) {
    $(".al-sw-mobile").each(function () {
        var swiperMb;
        var $this = $(this);
        var screenWidth = $this.data("screen");

        function initSwiper() {
            if (
                matchMedia(`only screen and (max-width: ${screenWidth}px)`)
                    .matches
            ) {
                if (!swiperMb) {
                    var preview = $this.data("preview");
                    var previewMd = $this.data("preview-md") || preview;
                    var spacing = $this.data("space");

                    swiperMb = new Swiper($this[0], {
                        slidesPerView: preview,
                        spaceBetween: spacing,
                        speed: 1000,
                        pagination: {
                            el: $this.find(".sw-pagination-mb")[0],
                            clickable: true,
                        },
                        navigation: {
                            nextEl: $this.find(".nav-prev-mb")[0],
                            prevEl: $this.find(".nav-next-mb")[0],
                        },

                        breakpoints: {
                            640: {
                                slidesPerView: previewMd,
                                spaceBetween: spacing,
                            },
                        },

                    });
                }
            } else {
                if (swiperMb) {
                    swiperMb.destroy(true, true);
                    swiperMb = null;
                    $this.find(".swiper-wrapper").removeAttr("style");
                    $this.find(".swiper-slide").removeAttr("style");
                }
            }
        }

        initSwiper();
        window.addEventListener("resize", function () {
            initSwiper();
        });
    });
}

// The legacy quick-view swiper/variant-scroll-sync block that used to live here
// (targeting .swiper-quickview) was built for the original static template,
// which pre-rendered every product's quick-view slides directly in the HTML.
// It doesn't apply to this theme: the quick-view modal here is populated and
// given its own Swiper instance per product by theme-quick-view.js (see
// render()/swiperEl.swiper there), so this block was not just redundant but
// actively broken — it tried to construct a Swiper on the modal's slide
// wrapper before any slides existed (empty until a product is opened), and it
// also collided with the main product gallery, which shared the same
// .swiper-quickview class name.

// A .al-swiper initialized while its Bootstrap tab pane is still hidden
// (display:none, e.g. every non-default tab in sections/tabbed-collection.liquid)
// measures its container as 0-width, so its slides end up mis-sized/uneven
// instead of the equal slidesPerView split. Re-measure it the moment its tab
// becomes visible.
document.addEventListener("shown.bs.tab", function (e) {
    var target = e.target.getAttribute("data-bs-target") || e.target.getAttribute("href");
    var pane = target && document.querySelector(target);
    if (!pane) return;
    pane.querySelectorAll(".swiper").forEach(function (el) {
        if (el.swiper) el.swiper.update();
    });
});
